{{#if label}}
  <label for="{{id}}" class="{{labelClass}}">{{t label}}</label>
{{/if}}
{{#if (equal helptext.position 'top')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}
<select id="{{id}}" class="{{class}}" {{#if attributes}}data-attributable{{/if}}>
  {{#options}}
    <option value="{{value}}" {{#if (equal value ../default_value)}}selected{{/if}}>{{t text}}</option>
  {{/options}}
</select>
{{#if (equal helptext.position 'bottom')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}